// Hooks
import { useDeleteUserMutation } from '@features/redux/apis/auth';
import { useState } from 'react';
import { useSelector } from 'react-redux';

// Styles
import { useStyles } from '../styles/UserActions.styles';

// Generic Components
import { Box, IconButton, Link, Typography } from '@mui/material';
import { Edit as EditIcon, Close as CloseIcon } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';
import { ConfirmModal } from '@components/dialogs/ConfirmModal';

// Fixed Scope Components
import { UserActionsEffects } from './UserActionsEffects';

// Consts, utils
import { AppRoutes } from '@consts/routes';

// Types
import type { User } from '@features/redux/apis/auth';
import type { RootState } from '@features/redux/store';

export const UserActions = ({ user }: { user: User }) => {
    const classes = useStyles();

    const [deleteId, setDeleteId] = useState<string | undefined>();
    const [deleteUser] = useDeleteUserMutation({
        fixedCacheKey: 'DeleteUser',
    });

    const userEmail = useSelector((state: RootState) => state.auth.TokenPayload?.email);
    // Don't allow users to perform actions on themselves
    const disabled = userEmail === user.Username;

    return (
        <>
            <UserActionsEffects />

            <ConfirmModal
                title='Confirm Deletion'
                open={Boolean(deleteId)}
                setOpen={() => setDeleteId(undefined)}
                onConfirm={() => deleteUser({ email: deleteId! })}>
                <Typography>Are you sure you want to delete {deleteId}?</Typography>
            </ConfirmModal>

            <Box className={classes.actionButtons}>
                <Link
                    component={RouterLink}
                    to={`${AppRoutes.ManageUser}?id=${user.sub}`}
                    sx={{ pointerEvents: disabled ? 'none' : 'auto' }}>
                    <IconButton className={`${classes.iconButton} ${classes.iconEdit}`} disabled={disabled}>
                        <EditIcon fontSize='inherit' />
                    </IconButton>
                </Link>

                <IconButton
                    className={classes.iconButtonError}
                    onClick={() => setDeleteId(user.Username)}
                    disabled={disabled}>
                    <CloseIcon fontSize='inherit' />
                </IconButton>
            </Box>
        </>
    );
};
